import { push } from 'react-router-redux'

import querystring from 'query-string'
import createConstant from '../../utils/createConst'
import { API_HOSTNAME } from '../../GlobalConfig'
import { convertObjectValuesToString } from '../../utils/object'

// import sliderMock from './slider.json'
// import categoryMock from './category.json'
// import officialMock from './official.json'
// import pasarMock from './pasar.json'
// import eventMock from './event.json'
// import infoMock from './info.json'
// import mitraMock from './mitra.json'

const SLIDER = createConstant('home/SLIDER')
const CATEGORY = createConstant('home/CATEGORY')
const OFFICIAL = createConstant('home/OFFICIAL')
const PASARMINA = createConstant('home/PASARMINA')
const INFOMINA = createConstant('home/INFOMINA')
const INFOMINA_PROMOTED = createConstant('home/INFOMINA_PROMOTED')
const EVENTMINA = createConstant('home/EVENTMINA')
const EVENTMINA_PROMOTED = createConstant('home/EVENTMINA_PROMOTED')
const MITRA = createConstant('home/MITRA')
const TESTIMINA = createConstant('home/TESTIMINA')
const BANNER_DROPDOWN = createConstant('home/BANNER_DROPDOWN')
const BANNER_PROMOTION = createConstant('home/BANNER_PROMOTION')
const SUBSCRIBE_NEWSLETTER = createConstant('home/SUBSCRIBE_NEWSLETTER')
const RESET_NEWSLETTER = createConstant('home/RESET_NEWSLETTER')
const CONTACT_US = createConstant('home/CONTACT_US')
const RESET_CONTACT_US = createConstant('home/RESET_CONTACT_US')
const SCROLL_TO = 'home/SCROLL_TO'

const initialState = {
  scrollToPasar: false,
  sliderRequest: false,
  sliderError: '',
  slider: undefined,
  categoryRequest: false,
  categoryError: '',
  category: undefined,
  officialRequest: false,
  officialError: '',
  official: undefined,
  infoMinaRequestPromoted: false,
  infoMinaErrorPromoted: '',
  infoMinaPromoted: undefined,
  infoMinaRequest: false,
  infoMinaError: '',
  infoMina: undefined,
  eventMinaPromotedRequest: false,
  eventMinaPromotedError: '',
  eventMinaPromoted: undefined,
  eventMinaRequest: false,
  eventMinaError: '',
  eventMina: undefined,
  mitraRequest: false,
  mitraError: '',
  mitra: undefined,
  subscribeNewsletterRequest: undefined,
  subscribeNewsletterError: undefined,
  subscribeNewsletter: undefined,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SLIDER.request:
      return {
        ...state,
        sliderRequest: true,
        sliderError: '',
      }
    case SLIDER.failed:
      return {
        ...state,
        sliderRequest: false,
        sliderError: action.error.message,
        slider: undefined,
      }
    case SLIDER.success:
      return {
        ...state,
        sliderRequest: false,
        sliderError: '',
        slider: action.result.result,
      }
    case CATEGORY.request:
      return {
        ...state,
        categoryRequest: true,
        categoryError: '',
      }
    case CATEGORY.failed:
      return {
        ...state,
        categoryRequest: false,
        categoryError: action.error.message,
        category: undefined,
      }
    case CATEGORY.success:
      return {
        ...state,
        categoryRequest: false,
        categoryError: '',
        category: action.result.result,
      }
    case OFFICIAL.request:
      return {
        ...state,
        officialRequest: true,
        officialError: '',
      }
    case OFFICIAL.failed:
      return {
        ...state,
        officialRequest: false,
        officialError: action.error.message,
        official: undefined,
      }
    case OFFICIAL.success:
      return {
        ...state,
        officialRequest: false,
        officialError: '',
        official: action.result.result,
      }
    case PASARMINA.request:
      return {
        ...state,
        pasarMinaRequest: true,
        pasarMinaError: '',
      }
    case PASARMINA.failed:
      return {
        ...state,
        pasarMinaRequest: false,
        pasarMinaError: action.error.message,
        pasarMina: undefined,
      }
    case PASARMINA.success:
      return {
        ...state,
        pasarMinaRequest: false,
        pasarMinaError: '',
        pasarMina: action.result.result,
        pasarMinaPagination: action.result.pagination,
      }
    case INFOMINA.request:
      return {
        ...state,
        infoMinaRequest: true,
        infoMinaError: '',
      }
    case INFOMINA.failed:
      return {
        ...state,
        infoMinaRequest: false,
        infoMinaError: action.error.message,
        infoMina: undefined,
      }
    case INFOMINA.success:
      return {
        ...state,
        infoMinaRequest: false,
        infoMinaError: '',
        infoMina: action.result.result,
      }
    case INFOMINA_PROMOTED.request:
      return {
        ...state,
        infoMinaRequestPromoted: true,
        infoMinaErrorPromoted: '',
      }
    case INFOMINA_PROMOTED.failed:
      return {
        ...state,
        infoMinaRequestPromoted: false,
        infoMinaErrorPromoted: action.error.message,
        infoMinaPromoted: undefined,
      }
    case INFOMINA_PROMOTED.success:
      return {
        ...state,
        infoMinaRequestPromoted: false,
        infoMinaErrorPromoted: '',
        infoMinaPromoted: action.result.result,
      }
    case EVENTMINA.request:
      return {
        ...state,
        eventMinaRequest: true,
        eventMinaError: '',
      }
    case EVENTMINA.failed:
      return {
        ...state,
        eventMinaRequest: false,
        eventMinaError: action.error.message,
        eventMina: undefined,
      }
    case EVENTMINA.success:
      return {
        ...state,
        eventMinaRequest: false,
        eventMinaError: '',
        eventMina: action.result.result,
      }
    case EVENTMINA_PROMOTED.request:
      return {
        ...state,
        eventMinaRequestPromoted: true,
        eventMinaErrorPromoted: '',
      }
    case EVENTMINA_PROMOTED.failed:
      return {
        ...state,
        eventMinaRequestPromoted: false,
        eventMinaErrorPromoted: action.error.message,
        eventMinaPromoted: undefined,
      }
    case EVENTMINA_PROMOTED.success:
      return {
        ...state,
        eventMinaRequestPromoted: false,
        eventMinaErrorPromoted: '',
        eventMinaPromoted: action.result.result,
      }
    case MITRA.request:
      return {
        ...state,
        mitraRequest: true,
        mitraError: '',
      }
    case MITRA.failed:
      return {
        ...state,
        mitraRequest: false,
        mitraError: action.error.message,
        mitra: undefined,
      }
    case MITRA.success:
      return {
        ...state,
        mitraRequest: false,
        mitraError: '',
        mitra: action.result.result,
      }
    case TESTIMINA.request:
      return {
        ...state,
        testiMinaRequest: true,
      }
    case TESTIMINA.success:
      return {
        ...state,
        testiMinaRequest: false,
        testiMina: action.result.result,
      }
    case TESTIMINA.failed:
      return {
        ...state,
        testiMinaRequest: false,
        testiMinaError: action.error.message,
      }
    case BANNER_DROPDOWN.request:
      return {
        ...state,
        bannerDropdownRequest: true,
      }
    case BANNER_DROPDOWN.success:
      return {
        ...state,
        bannerDropdownRequest: false,
        bannerDropdown: action.result.result,
      }
    case BANNER_DROPDOWN.failed:
      return {
        ...state,
        bannerDropdownRequest: false,
        bannerDropdownError: action.error.message,
      }
    case BANNER_PROMOTION.request:
      return {
        ...state,
        bannerPromotionRequest: true,
      }
    case BANNER_PROMOTION.success:
      return {
        ...state,
        bannerPromotionRequest: false,
        bannerPromotion: action.result.result,
      }
    case BANNER_PROMOTION.failed:
      return {
        ...state,
        bannerPromotionRequest: false,
        bannerPromotionError: action.error.message,
      }
    case SUBSCRIBE_NEWSLETTER.request:
      return {
        ...state,
        subscribeNewsletterRequest: true,
      }
    case SUBSCRIBE_NEWSLETTER.success:
      return {
        ...state,
        subscribeNewsletterRequest: false,
        subscribeNewsletter: action.result.success,
      }
    case SUBSCRIBE_NEWSLETTER.failed:
      return {
        ...state,
        subscribeNewsletterRequest: false,
        subscribeNewsletterError: action.error.message,
      }
    case RESET_NEWSLETTER:
      return {
        ...state,
        subscribeNewsletter: undefined,
      }
    case SCROLL_TO: {
      return {
        ...state,
        scrollToPasar: action.payload,
      }
    }
    case CONTACT_US.request:
      return {
        ...state,
        contactUsRequest: true,
        contactUsError: '',
      }
    case CONTACT_US.success:
      return {
        ...state,
        contactUsRequest: false,
        contactUs: action.result,
      }
    case CONTACT_US.failed:
      return {
        ...state,
        contactUsRequest: false,
        contactUsError: convertObjectValuesToString(action.error.errors),
      }
    case RESET_CONTACT_US:
      return {
        ...state,
        contactUs: undefined,
        contactUsError: '',
      }
    default:
      return state
  }
}

const options = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  mode: 'cors',
}

export const getSlider = () => ({
  types: SLIDER,
  promise: fetch(`${API_HOSTNAME}/v1/home/sliders`, options),
})

export const getCategory = () => ({
  types: CATEGORY,
  promise: fetch(`${API_HOSTNAME}/v1/home/menu?limit=60&includeSubcategories=false`, options),
})

export const getOfficial = () => ({
  types: OFFICIAL,
  promise: fetch(`${API_HOSTNAME}/v1/home/official_partners`, options),
})

export const getPasarMina = (qs = { promoted: true, limit: 8 }) => ({
  types: PASARMINA,
  promise: fetch(`${API_HOSTNAME}/v1/home/product?${querystring.stringify(qs)}`, options),
})

export const getEventMina = () => ({
  types: EVENTMINA,
  promise: fetch(`${API_HOSTNAME}/v1/home/mina/event?limit=6`, options),
})

export const getEventMinaPromoted = () => ({
  types: EVENTMINA_PROMOTED,
  promise: fetch(`${API_HOSTNAME}/v1/home/mina/event?promoted=true&limit=3`, options),
})

export const getInfoMina = () => ({
  types: INFOMINA,
  promise: fetch(`${API_HOSTNAME}/v1/home/mina/info`, options),
})

export const getInfoMinaPromoted = () => ({
  types: INFOMINA_PROMOTED,
  promise: fetch(`${API_HOSTNAME}/v1/home/mina/info?promoted=true&limit=4`, options),
})

export const getMitra = () => ({
  types: MITRA,
  promise: fetch(`${API_HOSTNAME}/v1/home/mitra`, options),
})

export const getTestimina = () => ({
  types: TESTIMINA,
  promise: fetch(`${API_HOSTNAME}/v1/home/tesimonial`),
})

export const getBannerDropdown = () => ({
  types: BANNER_DROPDOWN,
  promise: fetch(`${API_HOSTNAME}/v1/home/dropdown`),
})

export const getBannerPromotion = () => ({
  types: BANNER_PROMOTION,
  promise: fetch(`${API_HOSTNAME}/v1/home/ads`),
})

export const subscribeNewsletter = (email) => {
  const data = querystring.stringify(email)

  return {
    types: SUBSCRIBE_NEWSLETTER,
    promise: fetch(`${API_HOSTNAME}/v1/newsletter/subscribe?${data}`),
  }
}

export const resetNewsletter = () => ({ type: RESET_NEWSLETTER })

export const togglePasarminaScroll = payload => (dispatch) => {
  dispatch({
    type: SCROLL_TO,
    payload,
  })

  if (payload) {
    dispatch(push('/'))
  }
}

export const contactUs = (payload) => {
  const contactOpts = { ...options, method: 'POST', body: JSON.stringify(payload) }

  return {
    types: CONTACT_US,
    promise: fetch(`${API_HOSTNAME}/v1/contact-minapoli`, contactOpts),
  }
}

export const resetContactUs = () => ({ type: RESET_CONTACT_US })



// WEBPACK FOOTER //
// ./src/modules/Home/index.js